import React, { useState, useEffect, useRef } from "react";
import MaterialTable, { MTableToolbar } from "material-table";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import ContentLoader from "react-content-loader";
import axios from "axios";
import Tooltip from "@tippyjs/react";

import { getTrans as t } from "../../Localization/translations";
import { API } from "../../backend";
import authHeader from "../../services/auth-header";

function TermsConditions() {
    const tableRef = useRef();

    const [terms, setTerms] = useState([]);
    const [loading, setLoading] = useState(true);

    // 🔥 SINGLE STATE FOR UI FLOW
    const [mode, setMode] = useState("list"); // list | add | edit
    const [formData, setFormData] = useState({ name: "", value: "" });
    const [selectedId, setSelectedId] = useState(null);

    useEffect(() => {
        fetchTerms();
    }, []);

    // ✅ FETCH
    const fetchTerms = async () => {
        try {
            setLoading(true);

            const res = await axios.get(`${API}company/term-conditions/`, {
                headers: authHeader(),
            });

            setTerms(res.data);
        } catch (err) {
            console.error(err);
            toast.success("Failed to load terms", {
                position: "top-right",
                autoClose: 1000,
                theme: "light",
            });
        } finally {
            setLoading(false);
        }
    };

    // ✅ HANDLE INPUT
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // ✅ SAVE (ADD / EDIT)
    const handleSave = async () => {
        if (!formData.name.trim()) {
            toast.error("Name is required");
            return;
        }

        try {
            if (mode === "add") {
                await axios.post(
                    `${API}company/term-conditions/`,
                    formData,
                    { headers: authHeader() }
                );

                toast.success("Term Added Successfully");
            } else {
                await axios.put(
                    `${API}company/term-conditions/${selectedId}/`,
                    formData,
                    { headers: authHeader() }
                );

                toast.success("Term Updated Successfully");
            }

            // ✅ WAIT before switching screen
            setTimeout(() => {
                setMode("list");
                setFormData({ name: "", value: "" });
                fetchTerms();
            }, 1500);

        } catch (error) {
            toast.error("Failed to save term");
        }
    };

    // ✅ DELETE
    const handleDelete = (rowData) => {
        confirmAlert({
            message: `Delete "${rowData.name}"?`,
            buttons: [
                {
                    label: "Yes",
                    onClick: async () => {
                        try {
                            await axios.delete(
                                `${API}company/term-conditions/${rowData.id}/`,
                                { headers: authHeader() }
                            );

                            toast.success("Term Deleted Successfully", {
                                position: "top-right",
                                autoClose: 1500,
                                theme: "light",
                            });
                            fetchTerms();
                        } catch {
                            toast.error("Failed to Delete Term");
                        }
                    },
                },
                { label: "No" },
            ],
        });
    };

 


    // ADD / EDIT FORM UI

    if (mode === "add" || mode === "edit") {
        return (
            <div className="container-fluid">
                <div className="card">
                    <ToastContainer />

                    <div className="card-body">
                        <h5>
                            {mode === "add"
                                ? t("Add New Term")
                                : t("Edit Term")}
                        </h5>

                        <div className="col-lg-6">

                            <label className="col-lg-12 col-form-label required">
                                {t("Term Name")}{" "}
                                <Tooltip content={t("TermName_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                            </label>

                            <input
                                className="form-control"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder={t("Enter term name")}
                            />
                        </div>

                        {/* ✅ BUTTONS */}
                        <div className="text-left py-3">
                            <button
                                className="btn btn-primary btn-gradient-primary btn-md"
                                onClick={handleSave}
                            >
                                {mode === "add" ? t("Save") : t("Update")}
                            </button>

                            &nbsp;

                            <button
                                className="btn btn-secondary"
                                onClick={() => {
                                    setMode("list");
                                    setFormData({ name: "", value: "" });
                                }}
                            >
                                {t("Cancel")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-wrapper">
            <ToastContainer />

            <div className="content container-fluid">
                <div className="row show_contract show_invoice">
                    <div className="col-md-12">
                        <div className="body">
                            <div className="p-0">

                                <MaterialTable
                                    tableRef={tableRef}
                                    isLoading={loading}
                                    style={{
                                        backgroundColor: "var(--bs-table-bg)",
                                        borderBottomWidth: "1px",
                                        boxShadow:
                                            "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                    }}

                                    // ✅ TITLE + BUTTON (like Expenses)
                                    title={
                                        <div className="d-flex align-items-center">
                                            <h5 className="mb-0">{t("Terms & Conditions")}</h5>

                                            {/* <div className="ms-auto">
                                                <button
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => {
                                                        setFormData({ name: "", value: "" });
                                                        setMode("add");
                                                    }}
                                                >
                                                    + {t("New Term")}
                                                </button>
                                            </div> */}
                                        </div>
                                    }

                                    columns={[
                                        {
                                            title: t("Terms"),
                                            field: "name",
                                            headerStyle: {
                                                fontWeight: "bold",
                                                textAlign: "left",
                                            },
                                            cellStyle: {
                                                textAlign: "left",
                                                fontSize: 12,
                                            },
                                            render: (rowData) => (
                                                <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                                        {t("Term")}
                                                    </div>
                                                    <div>{rowData.name}</div>
                                                </>
                                            ),
                                        },

                                    ]}

                                    data={terms}

                                    actions={[
                                        {
                                            icon: () => (
                                                <img
                                                    src="/static/images/ic-edit.svg"
                                                    alt="edit"
                                                />
                                            ),
                                            tooltip: "Edit",
                                            onClick: (e, rowData) => {
                                                setFormData({
                                                    name: rowData.name,
                                                    value: rowData.value || "",
                                                });
                                                setSelectedId(rowData.id);
                                                setMode("edit");
                                            },
                                        },
                                        {
                                            icon: () => (
                                                <img
                                                    src="/static/images/ic-delete.svg"
                                                    alt="delete"
                                                />
                                            ),
                                            tooltip: "Delete",
                                            onClick: (e, rowData) =>
                                                handleDelete(rowData),
                                        },
                                    ]}

                                    components={{
                                        Toolbar: (props) => (
                                            <div className="d-flex align-items-center px-3 py-2">

                                                {/* LEFT: Default toolbar (title, etc.) */}
                                                <div className="flex-grow-1">
                                                    <MTableToolbar {...props} />
                                                </div>

                                                {/* RIGHT: Button */}
                                                <div>
                                                    <button
                                                        className="add-party add btn btn-primary mb-0"
                                                        onClick={() => {
                                                            setFormData({ name: "", value: "" });
                                                            setMode("add");
                                                        }}
                                                    >
                                                        + {t("New Term")}
                                                    </button>
                                                </div>

                                            </div>
                                        ),
                                    }}

                                    options={{
                                        headerStyle: {
                                            backgroundColor: "white",
                                            color: "#245C7F",
                                            fontSize: 12,
                                        },
                                        rowStyle: (rowData, index) =>
                                            index % 2 ? { backgroundColor: "#fff" } : {},
                                        sorting: true,
                                        search: false,
                                        toolbar: true, // keep true to show title properly
                                        paging: false,
                                        actionsColumnIndex: -1,
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TermsConditions;